<template>
  <div class="grid-view">
    <div class="main-content">
      <query-bill-payment
        ref="queryBillPayment"
        identify="queryBillPayment"
        view-source="billPaymentList"
        :show-real-clearing-state="searchConditions.showRealClearingState"
        :state="searchConditions.state"
        :paid-off="searchConditions.paidOff"
        :is-check-charge="searchConditions.isCheckCharge"
        :show-controlled-charge="searchConditions.showControlledCharge"
        :clearing-states="searchConditions.clearingStates"
        :show-wht="showWht"
        config-module="4100162"
        grid-config-module="410016201"
        @dataProviderChange="dataProviderChange"
        @rowDoubleClicked="rowDoubleClicked"
      >
        <div slot="operations">
          <el-button type="primary" @click="toDetail(false, null)">{{ $t('Payment.viewDetails') }}</el-button>
          <el-button type="primary" @click="toCollectInvoice">{{ $t('Payment.collectInvoice') }}</el-button>
          <!-- <el-button type="primary" @click="toPrint">{{ $t('Payment.print') }}</el-button> -->
          <el-dropdown
            split-button
            type="primary"
            style="margin: 0 5px;"
            @click="toPrint($t('Payment.print'))"
            @command="toPrint"
          >
            {{ $t('Payment.print') }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('Clearing.PrintByPaymentRequestNumber')">{{ $t('Clearing.PrintByPaymentRequestNumber') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="toCreatePayment">{{ $t('Payment.newPaymentRequest') }}</el-button>
          <el-button v-show="searchConditions.applicationStatus === 0" type="primary" @click="doCommit">{{ $t('Payment.submit') }}</el-button>
          <el-button
            v-show="(searchConditions.applicationStatus === 0 || searchConditions.applicationStatus === 4) && this.$checkPermission(['button_fmBillPaymentByJob_btnPaymentByJobDelete'])"
            type="danger"
            @click="doDelete"
          >{{ $t('Payment.delete') }}</el-button>
          <el-button v-permission="['button_fmBillPaymentByJob_btnPaymentByJobWithdraw']" type="primary" @click="toWithdraw">{{ $t('Message.Withdraw') }}</el-button>
          <el-button v-show="$checkPermission(['button_fmBillPaymentByJob_billPaymentHandle'])" no="24" type="primary" @click="processPaymentRequest">{{ $t('Payment.processPaymentRequest') }}</el-button>
        </div>
      </query-bill-payment>
    </div>
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      @selectedTemplate="updatePrintField"
    />
    <!--创建付款申请弹窗-->
    <bill-payment-creator-dialog ref="billPaymentCreator" :location="location" @reloadData="reloadData" />
    <!--付款申请弹窗-->
    <bill-payment-dialog
      v-if="billPaymentDialog.visible"
      :visible.sync="billPaymentDialog.visible"
      :title="billPaymentDialog.title"
      :bill-payment-uuid="billPaymentDialog.billPaymentUuid"
      :is-direct-payment="isDirectPayment"
      :location="location"
      @cancel="billPaymentDialog.visible = false"
      @saveSuccess="saveBillPaymentSuccess"
      @reloadData="reloadData"
    />
    <!--开票-->
    <make-invoice-dialog ref="invoice" view-source="billPaymentList" :location="location" @reloadData="reloadData" />
    <!-- 批量提交、批量同意、批量拒绝 错误弹窗-->
    <batch-submit-or-approve-dialog
      :visible.sync="batchSubmitOrApproveDialog.visible"
      :row-data="batchSubmitOrApproveDialog.rowData"
      :is-submit="true"
    />
  </div>
</template>

<script>
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import billPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPaymentByJob/billPaymentDialog'
import makeInvoiceStepOneDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/makeInvoiceStepOneDialog'
import queryBillPayment from '@/views/cargo/v0/Clearing/components/query/queryBillPaymentByJob'
import makeInvoiceDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/makeInvoiceDialog'
import { updateBillPaymentState, batchDelBillPayment, uploadHasPrint, checkLackInvoiceFlagFunc } from '@/api/clearing/billPayment'
import { autoBillPaymentWriteOffFunc } from '@/api/clearing/actualAmount'
import { cache, cacheName } from '@/utils/cacheManager'
import { getUserInfo } from '@/utils/auth'
import lodash from 'lodash'
import billPaymentCreatorDialog from '@/views/cargo/v0/Clearing/components/BillPaymentByJob/billPaymentCreatorDialog'
import { validateRoleByUserIdAndRoleName } from '@/api/role'
import { getLoading } from '@/utils/utilBaseElement'
import { workflowActionBatch } from '@/api/workflow'
import batchSubmitOrApproveDialog from '@/components/Cargo/Common/Wrokflow/batchSubmitOrApproveDialog'
import {
  APPLICATION_DIMENSION_BILL_PAYMENT,
  VIEW_SOURCE_BILL_PAYMENT_APPLY
} from '@/class/cargo/model/parameters/WorkflowConstants'
import { LOG_BILL_PAYMENT } from '@/class/cargo/model/parameters/SystemConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'BillPaymentByJobList',
  components: {
    cargoTemplateSelectorDialog,
    billPaymentDialog,
    makeInvoiceStepOneDialog,
    queryBillPayment, // 付款申请查询列表
    makeInvoiceDialog, // 开票弹出框
    billPaymentCreatorDialog, // 创建付款申请弹窗
    batchSubmitOrApproveDialog
  },
  props: {
    showWht: { type: Boolean, default: false } // 是否需要展示去Wht金额
  },
  data() {
    return {
      loading: false,
      searchConditions: {
        applicationStatus: 0,
        clearingStates: [], // 核销状态
        paidOff: -1, // 是否销账
        showControlledCharge: false,
        isCheckCharge: true,
        showRealClearingState: true,
        unCommittedRowData: [], // 未提交状态的表格数据
        unCommittedSearchConditions: {
          total: 0,
          pageNum: 1,
          pageSize: 20,
          requires: ['voucherNoCreateDate', 'targetVoucherNo'],
          snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
          jobStates: [] // 业务状态
        }, // 未提交状态的查询条件
        unVerifyRowData: [], // 未提交状态的表格数据
        unVerifySearchConditions: {
          total: 0,
          pageNum: 1,
          pageSize: 20,
          requires: ['voucherNoCreateDate', 'targetVoucherNo'],
          snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
          jobStates: [] // 业务状态
        }, // 待业务审批状态的查询条件
        financeUnVerifyRowData: [], // 待财务审批状态u的表格数据
        financeUnVerifySearchConditions: {
          total: 0,
          pageNum: 1,
          pageSize: 20,
          requires: ['voucherNoCreateDate', 'targetVoucherNo'],
          snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
          jobStates: [] // 业务状态
        }, // 待财务审批状态的查询条件
        verifiedRowData: [], // 审批通过状态的表格数据
        verifiedSearchConditions: {
          total: 0,
          pageNum: 1,
          pageSize: 20,
          requires: ['voucherNoCreateDate', 'targetVoucherNo'],
          snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
          jobStates: [] // 业务状态
        }, // 审批通过状态的查询条件
        unPaidOffRowData: [], // 未付清状态的表格数据
        unPaidOffSearchConditions: {
          total: 0,
          pageNum: 1,
          pageSize: 20,
          requires: ['voucherNoCreateDate', 'targetVoucherNo'],
          snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
          jobStates: [] // 业务状态
        }, // 未付清状态的查询条件
        allRowData: [], // 所有状态的表格数据
        allSearchConditions: {
          total: 0,
          pageNum: 1,
          pageSize: 20,
          requires: ['voucherNoCreateDate', 'targetVoucherNo'],
          snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
          jobStates: [] // 业务状态
        } // 所有状态的查询条件
      },
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      hasBusinessVerify: false, // 是否有业务审批权限
      isDepartmentPermit: false, // 部门审批
      hasBackPrivilege: false, // 是否有退回权限
      hasFinanceVerify: false, // 财务审核权限
      isDirectPayment: false,
      isPaymentApplyFinancialAudit: false, // 待业务审核页面可以直接财务审核
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'BILLPAYMENT',
        data: {
          BILLING_LIST_UUID: []
        }
      },
      billPaymentDialog: { // 付款申请弹窗【查看明细】
        visible: false,
        title: '',
        billPaymentUuid: ''
      },
      makeInvoiceDialog: { // 收票弹窗页
        keys: [], // 此处统一传递uuid集合，后续会请求后台，组装树状结构
        isAr: false,
        step: '',
        hedgeKeys: [], // 对冲开票uuid集合
        isHedge: false,
        isSkipInvoiceFrom: false,
        makeInvoiceMethod: 5 // 开票方式:5代表账单
      },
      batchSubmitOrApproveDialog: {
        visible: false,
        rowData: []
      },
      viewSource: VIEW_SOURCE_BILL_PAYMENT_APPLY.code,
      location: LOG_BILL_PAYMENT.code
    }
  },
  watch: {
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    let shae = false // 上海空运出口, 类似于 Department permit
    let isDirectPayment = false
    const roleMap = await validateRoleByUserIdAndRoleName(['上海空运付款', '付款申请直达']).then(res => {
      return res.data
    })
    if (roleMap) {
      if (roleMap.hasOwnProperty('上海空运付款') && roleMap['上海空运付款']) {
        shae = true
      }
      if (roleMap.hasOwnProperty('付款申请直达') && roleMap['付款申请直达']) {
        shae = true
        isDirectPayment = true
      }
    }
    this.isDirectPayment = isDirectPayment
    const billPaymentDepartmentPermit = Number(cache.config.get('BillPaymentDepartmentPermit'))
    if (billPaymentDepartmentPermit >= 1 || shae) {
      this.isDepartmentPermit = true
    } else {
      this.isDepartmentPermit = false
    }
    const paymentApplyFinancialAudit = Number(cache.config.get('PaymentApplyFinancialAudit'))
    if (paymentApplyFinancialAudit >= 1) {
      this.isPaymentApplyFinancialAudit = true
    } else {
      this.isPaymentApplyFinancialAudit = false
    }
    this.hasBusinessVerify = this.$checkPermission(['button_ACPayAuth_business'])
    const pd = this.$checkPermission(['button_ACPayAuth_department'])
    const p = this.$checkPermission(['button_ACPayAuth_business']) || getUserInfo().admin
    if (this.isDepartmentPermit) {
      this.hasBackPrivilege = pd || p
    } else {
      this.hasBackPrivilege = p
    }
    this.hasFinanceVerify = this.$checkPermission(['button_ACPayAuth_financeVerify'])
  },
  beforeMount() {
  },
  mounted() {
  },
  methods: {
    // 查看详情
    toDetail(doubleClick = false, row = null) {
      let billPayment = null
      if (doubleClick) { // 双击查看
        billPayment = row
      } else {
        const chooseRows = this.$refs.queryBillPayment.getSelections()
        if (chooseRows && chooseRows.length > 0) {
          billPayment = chooseRows[0]
        }
      }
      if (!billPayment) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      this.billPaymentDialog.billPaymentUuid = billPayment.uuid
      this.billPaymentDialog.title = this.$t('CargoMsg.Cargo_ViewPaymentRequest')
      this.billPaymentDialog.visible = true
    },
    // 办理按钮点击事件
    processPaymentRequest() {
      // 获取选中的付款申请单
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }

      // 验证选中的付款申请单
      for (const row of chooseRows) {
        // 判断逻辑：只有"审批状态"="审批通过" 并且 "核销状态"！="全部核销"的付款申请才能点击此按钮
        // finApproveState: 1=审批通过
        // paidOff: 0=未核销, 1=部分核销, 2=全部核销
        console.log('row', row.state, row.realClearingState)
        if (row.state !== 10 || row.realClearingState === 2) {
          this.$message.error(this.$t('CargoMsg.Cargo_OnlyApprovedAndNotFullyWrittenOffCanProcess'))
          return
        }
      }

      // 确认后执行自动销账
      this.$confirm(this.$t('CargoMsg.Cargo_ConfirmAutoWriteOffSelectedPaymentRequests'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(async() => {
        // 调用自动销账接口 - 传递付款申请UUID列表
        this.loading = getLoading()
        const uuidList = chooseRows.map(item => item.uuid)
        await autoBillPaymentWriteOffFunc(uuidList).then(res => {
          if (res) {
            this.$message.success(this.$t('CargoMsg.Cargo_ProcessSuccessWrittenOff', [chooseRows.length || 0]))
            // 刷新列表
            this.$refs.queryBillPayment.toQueryBillPaymentList()
          }
        }).catch(err => {
          this.$message.error(err.message || this.$t('CargoMsg.Cargo_ProcessFailed'))
        }).finally(() => {
          this.loading.close()
        })
      }).catch(() => {
        // 取消操作
      })
    },
    // 收票按钮触发事件
    toCollectInvoice() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      let message = ''
      // 选中数据中是否存在可开票账单
      let isC = false
      for (const bp of chooseRows) {
        if (!bp.notInvoiceByCharge) {
          if (message) {
            message += ','
          }
          message = message + bp.billPaymentNo
        } else {
          isC = true
        }
      }
      if (message && isC) {
        this.$message.warning('包含已开票的费用，请重新选择！付款申请单号：' + message)
        return
      } else if (message && !isC) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoneAnyBillable'))
        return
      }
      this.makeInvoiceDialog.isAr = false
      this.makeInvoiceDialog.isHedge = false
      this.makeInvoiceDialog.isSkipInvoiceFrom = false
      const keys = []
      for (const billPayment of chooseRows) {
        if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0) {
          keys.push(billPayment.uuid)
        }
      }
      this.makeInvoiceDialog.keys = keys
      this.makeInvoiceDialog.step = 'step1'
      this.$refs.invoice.makeInvoice({ ...this.makeInvoiceDialog })
    },
    // 创建付款申请
    toCreatePayment() {
      this.$refs.billPaymentCreator.createBillPayment({ step: 'step1', title: this.$t('CargoMsg.Cargo_CreatePaymentRequestChooseFees') })
    },
    // 打印按钮触发事件
    toPrint(command) {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      const keys = []
      for (const billPayment of chooseRows) {
        if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0) {
          keys.push(billPayment.uuid)
        }
      }
      const params = {}
      const multiplePrint = chooseRows.length > 1 && command === this.$t('Clearing.PrintByPaymentRequestNumber') // 是否按照多个打印
      if (chooseRows.length === 1 || params.multiplePrint) {
        params.BILLPAYMENT_UUID = chooseRows[0].uuid
        params.BILL_PAYMENT_UUID = chooseRows[0].uuid
        if (multiplePrint) {
          params.multiplePrint = true
          params.multipleBillPaymentUuid = keys
        }
        this.templateSelectorDialog.data = params
        this.templateSelectorDialog.category = 'BILLPAYMENT'
        this.templateSelectorDialog.visible = true
      } else {
        params.BILL_PAYMENT_UUID_LIST = keys
        this.templateSelectorDialog.data = params
        this.templateSelectorDialog.category = 'BILLPAYMENT_LIST'
        this.templateSelectorDialog.visible = true
      }
    },
    // 提交按钮触发事件
    async doCommit() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSPATS'))
        return
      }

      // 单选校验：提交操作只支持单选
      if (chooseRows.length > 1) {
        this.$message.warning('目前提交操作只支持单选!')
        return
      }

      // 1. 收集选中的付款申请数据（包含付款类型）
      const billPaymentList = []
      for (const billPayment of chooseRows) {
        if (billPayment.state !== 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PSUSPAF'))
          return
        }
        if (billPayment.uuid && billPayment.version) {
          billPaymentList.push({
            uuid: billPayment.uuid,
            version: billPayment.version,
            billPaymentNo: billPayment.billPaymentNo || '',
            branchId: billPayment.branchId,
            paymentType: billPayment.paymentType || '' // 付款类型
          })
        }
      }

      if (billPaymentList.length === 0) {
        return
      }

      // 2. 付款类型判断：检查是否有"专项费用申请"（paymentType = "1" 表示专项费用申请）
      const specialFeeList = billPaymentList.filter(item => item.paymentType === '1')
      if (specialFeeList.length > 0) {
        const specialFeeNos = specialFeeList.map(item => item.billPaymentNo).join('，')
        this.$message.warning(`付款申请单号:${specialFeeNos} 付款类型为:专项费用申请,专项费用付款申请目前只能进入详情页进行提交操作`)
        return
      }

      // 3. 同时调用两个校验接口（并行调用）
      const validationResults = [] // 存储每条数据的校验结果

      for (const billPayment of billPaymentList) {
        // 并行调用两个校验接口
        const [invoiceRes, ruleRes] = await Promise.all([
          checkLackInvoiceFlagFunc({ uuid: billPayment.uuid }).catch(e => ({ data: 0 })),
          (async() => {
            const useCheckRule = Number(cache.config.get('useCheckRule')) === 1
            if (!useCheckRule) return { data: false }
            try {
              const result = await JobUtils.hasCheckRuleCondition(
                true,
                29, // NODE_BILL_PAYMENT_SAVE
                this.$store.getters.currentOfficeId
              )
              return { data: result }
            } catch (e) {
              console.warn('规则检查接口调用失败', e)
              return { data: true } // 接口失败默认未通过
            }
          })()
        ])

        // 判断校验结果
        // - 发票检查：data = 1 表示通过
        // - 规则检查：data = false 表示通过
        const invoicePassed = invoiceRes && invoiceRes.data === 1
        const rulePassed = ruleRes && ruleRes.data === false

        validationResults.push({
          ...billPayment,
          invoicePassed,
          rulePassed,
          passed: invoicePassed && rulePassed
        })
      }

      // 4. 显示校验结果提示
      const failedList = validationResults.filter(item => !item.passed)
      const passedList = validationResults.filter(item => item.passed)

      if (failedList.length > 0) {
        const failedNos = failedList.map(item => item.billPaymentNo).join('，')
        this.$message.warning(`付款申请号：${failedNos} 未通过校验检查，请注意！，但不影响提交操作`)
      }

      if (passedList.length > 0) {
        const passedNos = passedList.map(item => item.billPaymentNo).join('，')
        this.$message.success(`付款申请号：${passedNos} 校验通过`)
      }

      // 5. 执行提交接口（无论校验结果如何，都执行提交）
      if (billPaymentList.length > 0) {
        const keys = billPaymentList.map(item => ({ uuid: item.uuid, version: item.version }))
        const allBillPaymentNos = billPaymentList.map(item => item.billPaymentNo).join('，')

        if (parseInt(cache.config.get('BPM_StartOldApproval')) === 0) {
          // 发起bpm审批
          const params = []
          for (const billPayment of billPaymentList) {
            const param = {
              documentConfigId: 1,
              docId: billPayment.uuid,
              docNo: billPayment.billPaymentNo,
              actionType: 7000,
              officeId: billPayment.branchId,
              applicationDimension: APPLICATION_DIMENSION_BILL_PAYMENT.code
            }
            params.push(param)
          }
          this.doWorkflowActionBatch(params)
          return
        }

        const params = {
          billPayments: keys,
          state: this.isDirectPayment ? 2 : 1,
          operation: 'commit'
        }
        updateBillPaymentState(params).then(res => {
          this.$message.success(`付款申请号：${allBillPaymentNos} 已提交成功`)
        }).catch().finally(() => {
          // 刷新列表数据
          this.$refs.queryBillPayment.toQueryBillPaymentList()
        })
      }
    },
    // 删除按钮触发事件
    doDelete() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSPATD'))
        return
      }
      const list = []
      const noList = []
      for (const billPayment of chooseRows) {
        if (billPayment.state === 0) {
          list.push(billPayment)
        } else {
          noList.push(billPayment)
        }
      }
      if (!(noList.length === 0 && list.length > 0)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSUSPAF'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_STDTPA'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const mapBillPayment = []
        for (const billPayment of list) {
          if (billPayment.uuid && billPayment.version) {
            const map = {
              uuid: billPayment.uuid,
              version: billPayment.version
            }
            if (mapBillPayment.indexOf(map) < 0) {
              mapBillPayment.push(map)
            }
          }
        }
        batchDelBillPayment(mapBillPayment, this.location).then(res => {
          this.$refs.queryBillPayment.toQueryBillPaymentList()
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
        }).catch().finally()
      }).catch(() => {
      })
    },
    // 撤回按钮触发事件
    toWithdraw() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSPATW'))
        return
      }
      const index = chooseRows.findIndex(p => p.state !== 1 && p.state !== 9)
      if (index >= 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSSPAF'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_STWTPA'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(async() => {
        const keys = []
        const bpmParams = []
        for (const billPayment of chooseRows) {
          if (billPayment.state === 1) {
            if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0 && billPayment.version) {
              keys.push({ uuid: billPayment.uuid, version: billPayment.version })
            }
          } else if (billPayment.state === 9) {
            // bpm撤销流程
            const param = {
              documentConfigId: 1,
              docId: billPayment.uuid,
              actionType: 7004,
              officeId: billPayment.branchId
            }
            bpmParams.push(param)
          }
        }
        if (keys.length > 0) {
          const params = {
            billPayments: keys,
            state: 0,
            operation: 'withdraw'
          }
          await updateBillPaymentState(params).then(res => {
            this.$message.success(this.$t('CargoMsg.Cargo_WithdrawSuccessfully'))
            this.$refs.queryBillPayment.toQueryBillPaymentList()
          }).catch().finally()
        }
        // bpm撤销流程
        if (bpmParams.length > 0) {
          this.doWorkflowActionBatch(bpmParams)
        }
      }).catch(() => { })
    },
    // 重新加载列表数据
    reloadData(data) {
      this.$refs.queryBillPayment.toQueryBillPaymentList(data)
    },
    // 保存成功回调函数
    saveBillPaymentSuccess(billPayments = []) {
      this.$refs.queryBillPayment.refreshRowData(billPayments)
    },
    // 列表数据发生变更
    dataProviderChange({ data, searchConditions }) {
      const applicationStatus = this.searchConditions.applicationStatus
      if (applicationStatus === 0) {
        this.searchConditions.unCommittedRowData = lodash.cloneDeep(data)
        this.searchConditions.unCommittedSearchConditions = lodash.cloneDeep(searchConditions)
      } else if (applicationStatus === 1) {
        this.searchConditions.unVerifyRowData = lodash.cloneDeep(data)
        this.searchConditions.unVerifySearchConditions = lodash.cloneDeep(searchConditions)
      } else if (applicationStatus === 2) {
        this.searchConditions.financeUnVerifyRowData = lodash.cloneDeep(data)
        this.searchConditions.financeUnVerifySearchConditions = lodash.cloneDeep(searchConditions)
      } else if (applicationStatus === 3) {
        this.searchConditions.verifiedRowData = lodash.cloneDeep(data)
        this.searchConditions.verifiedRowData = lodash.cloneDeep(searchConditions)
      } else if (applicationStatus === 4) {
        this.searchConditions.unPaidOffRowData = lodash.cloneDeep(data)
        this.searchConditions.unPaidOffRowData = lodash.cloneDeep(searchConditions)
      } else {
        this.searchConditions.allRowData = lodash.cloneDeep(data)
        this.searchConditions.allSearchConditions = lodash.cloneDeep(searchConditions)
      }
    },
    // 列表双击事件
    rowDoubleClicked(billPayment = null) {
      this.toDetail(true, billPayment)
    },
    doWorkflowActionBatch(params) {
      this.loading = getLoading()
      workflowActionBatch(params).then(res => {
        if (!res.data || res.data.length === 0) {
          this.$message.success(this.$t('SeaExport.Submission') + this.$t('CargoMsg.Cargo_ApprovedSuccess'))
        } else {
          this.batchSubmitOrApproveDialog.visible = true
          this.batchSubmitOrApproveDialog.rowData = res.data
        }
        this.$refs.queryBillPayment.toQueryBillPaymentList()
      }).catch(() => {
        this.loading.close()
      }).finally(() => {
        this.loading.close()
      })
    },
    updatePrintField(selectedTemplate = null) {
      // 只处理打印的逻辑，非打印触发不处理
      if (selectedTemplate && selectedTemplate.previewType) {
        return
      }
      const keys = []
      if (this.templateSelectorDialog.data.BILLPAYMENT_UUID) {
        keys.push(this.templateSelectorDialog.data.BILLPAYMENT_UUID)
      } else {
        Object.assign(keys, this.templateSelectorDialog.data.BILL_PAYMENT_UUID_LIST)
      }
      this.loading = getLoading()
      uploadHasPrint(keys)
        .then(res => {
          if (res.ok && res.data) {
            this.$refs.queryBillPayment.toQueryBillPaymentList()
          }
        }).catch(() => { this.loading.close() }).finally(() => { this.loading.close() })
    }
  }
}
</script>

<style lang="scss">
</style>
